<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
  <!-- <p>
  Please contact Michell Nguyen at
  <a href="mailto:michell@cahcc.com">michell@cahcc.com</a>
  or call us &nbsp;at (916) 444-2221 for more information about the benefits
  of becoming a Sponsor&nbsp;
</p> -->
</div>

<div id="businessesLogoSection" class="col-md-10 innerContainer mt-5 pb-5">
  @for (text of texts; track text) {
    <div>
      <p>
        {{ text.text1 }}
      </p>
      <p>{{ text.text2 }}</p>
      <p>{{ text.text3 }}</p>
      <strong>{{ text.listTitle }}</strong>
      <ul>
        <li>{{ text.list1 }}</li>
        <li>{{ text.list2 }}</li>
        <li>{{ text.list3 }}</li>
        <li>{{ text.list4 }}</li>
        <li>{{ text.list5 }}</li>
        <li>{{ text.list6 }}</li>
      </ul>
    </div>
  }

  @for (secondList of secondLists; track secondList) {
    <div class="pb-5">
      <strong>{{ secondList.listTitle }}</strong>
      <ul>
        <li>{{ secondList.list1 }}</li>
        <li>{{ secondList.list2 }}</li>
        <li>{{ secondList.list3 }}</li>
        <li>{{ secondList.list4 }}</li>
      </ul>
    </div>
  }

  <!-- Corporate Sustaining Partners -->
  <div class="col-md-8">
    <h2 class="businessTitle pb-3" style="text-transform: uppercase;">
      Corporate Sustaining Partners
    </h2>
  </div>
  <div class="row pb-3">
    @for (first of firsts; track first) {
      <div
        class="col-lg-3 col-md-6 mb-3 d-flex flex-column"
        >
        <div class="card mb-4 h-100 border-0" style="height: 20rem;">
          <mdb-card>
            <a href="{{ first.href }}" target="_blank">
              <img
                src="{{ first.img }}"
                class="card-img-top"
                alt="{{ first.alt }}"
                title="{{ first.title }}"
                />
              </a>
            </mdb-card>
          </div>
        </div>
      }
    </div>
    <hr />
    <!-- Corporate Partners -->
    <div id="Partners" class="col-md-8 mt-5">
      <h2 class="businessTitle pb-3" style="text-transform: uppercase;">
        Corporate Partners
      </h2>
    </div>
    <div class="row pb-3">
      @for (partner of partners; track partner) {
        <div
          class="col-lg-3 col-md-6 mb-5 d-flex flex-column"
          >
          <div class="card mb-4 h-100 border-0" style="height: 20rem;">
            <mdb-card>
              <a href="{{ partner.href }}" target="_blank">
                <img
                  src="{{ partner.img }}"
                  class="card-img-top"
                  alt="{{ partner.alt }}"
                  title="{{ partner.title }}"
                  />
                </a>
              </mdb-card>
            </div>
          </div>
        }
      </div>
      <hr />
      <!-- Corporate Member -->
      <div id="members" class="col-md-8 mt-5">
        <h2 class="businessTitle pb-3" style="text-transform: uppercase;">
          Corporate Member
        </h2>
      </div>
      <div class="row pb-3">
        @for (member of members; track member) {
          <div
            class="col-lg-3 col-md-6 mb-5 d-flex flex-column"
            >
            <div class="card mb-4 h-100 border-0" style="height: 20rem;">
              <mdb-card>
                <a href="{{ member.href }}" target="_blank">
                  <img
                    src="{{ member.img }}"
                    class="card-img-top"
                    alt="{{ member.alt }}"
                    title="{{ member.title }}"
                    />
                  </a>
                </mdb-card>
              </div>
            </div>
          }
        </div>
      </div>
